/**
 * Product Card Block — opt into parent List's generic child-count context.
 *
 * List only exposes `data-list-child-count` / `--list-child-count`.
 * Maps that into `.product-card-block` local modifiers so stylesheet
 * rules never select `.list-block` or collide with theme `.product-card`.
 */
(function () {
  if (window.__mammotionProductCardJsBound) return;
  window.__mammotionProductCardJsBound = true;

  const COUNT_CLASS_PREFIX = 'product-card-block--list-count-';

  /**
   * @param {HTMLElement} card
   */
  function applyListContext(card) {
    const list = card.closest('[data-list-child-count]');
    if (!list) return;

    const count = list.getAttribute('data-list-child-count') || '0';
    card.dataset.listSiblingCount = count;
    card.classList.add('product-card-block--in-list');
    [...card.classList]
      .filter((name) => name.startsWith(COUNT_CLASS_PREFIX))
      .forEach((name) => card.classList.remove(name));
    card.classList.add(`${COUNT_CLASS_PREFIX}${count}`);
  }

  /**
   * @param {ParentNode} [scope]
   */
  function initAll(scope) {
    const root = scope || document;
    root.querySelectorAll('.product-card-block').forEach(applyListContext);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
